import { render, staticRenderFns } from "./CollectionListItem.vue?vue&type=template&id=6a9d5ed6"
import script from "./CollectionListItem.vue?vue&type=script&lang=js"
export * from "./CollectionListItem.vue?vue&type=script&lang=js"
import style0 from "./CollectionListItem.vue?vue&type=style&index=0&id=6a9d5ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports